module.exports = __webpack_public_path__ + "static/media/woah.af39283b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/gif/woah.gif
// module id = 706
// module chunks = 0